import React, { useCallback, useEffect, useState } from 'react';
import { SidePanel } from '../../../common/SidePanel';
import QueueInfoPanel from '../../../common/QueueInfo/QueueInfo';
import AddMember from './AddMember';
import PauseQueue from './PauseQueue';
import { countGuestStatuses } from '../Dashboard/Analitics_functions/Analitics';
import StatsCard from './StatsCard';
import classes from './QueueSidePanel.module.scss';

function QueueSidePanel({ queueInfo, isAdmin = true, onAddGuest }) {
  const [calcStatuses, setCalcStatuses] = useState({
    guestsServed: 0,
    waitingGuests: 0,
    canceledGuests: 0,
  });

  useEffect(() => {
    if (queueInfo.daily_stats) {
      const data = countGuestStatuses(queueInfo.daily_stats, true);
      setCalcStatuses((prev) => ({
        ...prev,
        ...data,
      }));
    } else {
      setCalcStatuses({ guestsServed: 0, waitingGuests: 0, canceledGuests: 0 });
    }
  }, [queueInfo]);

  return (
    <SidePanel>
      {isAdmin ? (
        <>
          <div>
            <QueueInfoPanel queueInfo={queueInfo} isAdmin={isAdmin} />
            {queueInfo.status === 'Active' && (
              <AddMember queueInfo={queueInfo} onAddGuest={onAddGuest} />
            )}
            <PauseQueue
              queueId={queueInfo.queueId}
              queueStatus={queueInfo.status}
            />
          </div>
          {
            <div className={classes['cardsWrap']}>
              <StatsCard
                title="Total"
                value={
                  calcStatuses.guestsServed +
                  calcStatuses.waitingGuests +
                  calcStatuses.canceledGuests
                }
              />
              <StatsCard title="Waiting" value={calcStatuses.waitingGuests} />
              <StatsCard title="Served" value={calcStatuses.guestsServed} />
              <StatsCard title="Removed" value={calcStatuses.canceledGuests} />
            </div>
          }
        </>
      ) : (
        <></>
      )}
    </SidePanel>
  );
}
export default QueueSidePanel;
